import styled from 'styled-components';
import { flexCenter, circle } from '../../../../helpers/style-helpers';

export const QuestionnaireWidgetSC = styled.div`
  div.questionnaire-widget__body {
    padding: 16px;

    .mi-name {
      font-size: 14px;
    }
  }
`;

export const QuestionnaireDetailSC = styled.div`
  padding: 68px 22px 24px;

  h3 {
    font-size: 20px;
    line-height: 1.5;
    font-weight: bold;
    margin-bottom: 0;
  }

  .qd-subtitle {
    font-size: 14px;
    opacity: 0.4;
    line-height: 1.42;
    font-weight: bold;
    margin-bottom: 22px;
  }
`;

export const QuestionnaireAnswerSC = styled.div`
  margin-bottom: 24px;

  h5 {
    flex: 1;
    opacity: 0.6;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0;
  }

  .qa-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .qa-icon {
    ${flexCenter}

    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .qa-options {
    margin-left: 32px;
  }

  .qa-option {
    display: flex;
    align-items: center;
    line-height: 1.4;
    font-weight: 800;
    font-size: 14px;
  }

  .qa-dot {
    ${circle(10)}

    margin-right: 8px;
    background: linear-gradient(270deg, #6ae59f 0%, #4bc881 100%);
    box-shadow: 0 2px 8px 0 rgba(106, 229, 159, 0.4);
  }
`;
